'use client'
import { __awaiter } from '../../../_virtual/_tslib.js';

/**
 * Generates an ECDH key pair for cryptographic operations.
 * Uses the P-256 curve for key generation, which provides 128-bit security level.
 *
 * @returns {Promise<{publicKey: CryptoKey, privateKey: CryptoKey}>} A promise that resolves to an object containing:
 *   - publicKey: The generated public key
 *   - privateKey: The generated private key
 */
const createKeyPair = () => __awaiter(void 0, void 0, void 0, function* () {
    const keyPair = yield crypto.subtle.generateKey({
        name: 'ECDH',
        namedCurve: 'P-256',
    }, true, ['deriveKey', 'deriveBits']);
    return {
        privateKey: keyPair.privateKey,
        publicKey: keyPair.publicKey,
    };
});

export { createKeyPair };
